export default __webpack_public_path__ + "images/5_Middagstips.jpeg";